module.exports = __webpack_public_path__ + "static/media/IconStarGray.79e3cb3e.svg";